import { Box } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';
import { FlexBox } from '../common/Reusables';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import DashboardTab from '../Onboarding/Dashboard/Tab';
import Guides from './Guides';
import EssentialTopics from './EssentialTopics';
import Support from './Support';
const HelpAndLearn = ({ state, setState }) => {
  const [value, setValue] = useState(0);
  const [stage, setStage] = useState(0);

  const content = {
    1: <Guides stage={stage} setStage={setStage} />,
    2: <EssentialTopics stage={stage} setStage={setStage} />,
    0: <Support stage={stage} setStage={setStage} />
  };

  return (
    <HelpAndLearn.Wrapper>
      <FlexBox className='heading-container'>
        <div className='heading'>Help & Support</div>
        <ChevronLeftIcon
          htmlColor='#2898a4'
          onClick={() => setState((prev) => !prev)}
        />
      </FlexBox>

      <Box p='0 21px'>
        {(stage === 0 || stage === 1 || stage === 2) && (
          <DashboardTab
            labels={['Support', 'Videos', 'How Tos']}
            minWidth='32%'
            value={value}
            handleChange={(_, newValue) => {
              setValue(newValue);
              setStage(0);
            }}
            justifyContent='normal'
          />
        )}

        {content[value]}
      </Box>
    </HelpAndLearn.Wrapper>
  );
};

export default HelpAndLearn;

HelpAndLearn.Wrapper = styled(Box)`
  margin: -20px;
  .heading-container {
    background: #eaf8fa;
    padding: 40px 13px 18px 14px;
    margin-bottom: 24px;
    .heading {
      font-weight: 600;
      font-size: 24px;
      line-height: 128.86%;
      color: #2898a4;
    }
    svg {
      width: 31.79px;
      height: 30px;
      cursor: pointer;
    }
  }
  .container {
    display: flex;
    margin: 1rem 0 0.5rem 0;
    cursor: pointer;
    .text {
      margin-left: 1rem;
      .heading {
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 18px;
        color: #545454;
      }
      .sub {
        font-weight: normal;
        font-size: 12.64px;
        line-height: 117.86%;
        color: #545454;
      }
    }
  }
`;
